export const maximumDocumentSize = 10; // MiB
export const defaultLinkStyle = "wikilink";
